module.exports = __webpack_public_path__ + "img/side-effects-graphic.f8ba2b35.png";